import { default as domainCatalogGrid } from './grid/services'

export default {
    domainCatalogGrid
}
